module.exports = __webpack_public_path__ + "static/media/kathy_tran_manager.65fd4e7f.png";